import { useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { Panel, TextField, RowsEditor, SaveButton, lines } from "@/components/admin/Panel";

const Toggle = ({ label, checked, onChange, testid }) => (
  <label className="flex items-center gap-3 text-sm"><Switch checked={checked} onCheckedChange={onChange} data-testid={testid} /> {label}</label>
);

export const ContentForm = ({ settings, reload }) => {
  const { reload: reloadSite } = useSite();
  const [c, setC] = useState({ ...settings.content, amenities_text: settings.content.amenities.join("\n"), rules_text: settings.content.house_rules.join("\n") });
  const [busy, setBusy] = useState(false);
  const k = (key) => (v) => setC({ ...c, [key]: v });
  const save = async () => {
    setBusy(true);
    const { amenities_text, rules_text, ...rest } = c;
    try {
      await api.put("/admin/content", { ...rest, amenities: lines(amenities_text), house_rules: lines(rules_text), rating: Number(c.rating), review_count: Number(c.review_count) });
      toast.success("Content saved"); reload(); reloadSite();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Panel title="Text & descriptions" testid="content-panel">
        <div className="space-y-4">
          <TextField area rows={6} label="Welcome message" value={c.welcome} onChange={k("welcome")} testid="content-welcome" />
          <TextField area rows={2} label="Space introduction" value={c.space_intro} onChange={k("space_intro")} testid="content-space-intro" />
          <div><p className="text-sm font-medium mb-2">Space highlights</p><RowsEditor rows={c.space_items} setRows={k("space_items")} fields={[["title", "Title"], ["text", "Description"]]} blank={{ title: "", text: "" }} testid="content-space-items" /></div>
          <TextField area rows={5} label="Amenities (one per line)" value={c.amenities_text} onChange={k("amenities_text")} testid="content-amenities" />
          <TextField area rows={4} label="House rules (one per line)" value={c.rules_text} onChange={k("rules_text")} testid="content-rules" />
          <div><p className="text-sm font-medium mb-2">Location highlights</p><RowsEditor rows={c.location_items} setRows={k("location_items")} fields={[["title", "Place"], ["detail", "Detail"]]} blank={{ title: "", detail: "" }} testid="content-location" /></div>
          <div><p className="text-sm font-medium mb-2">FAQs</p><RowsEditor rows={c.faqs} setRows={k("faqs")} fields={[["q", "Question"], ["a", "Answer"]]} blank={{ q: "", a: "" }} testid="content-faqs" /></div>
        </div>
      </Panel>
      <Panel title="Contact, address & reputation" testid="contact-panel">
        <div className="grid sm:grid-cols-2 gap-4">
          <TextField label="Contact email" value={c.contact_email} onChange={k("contact_email")} testid="content-contact-email" />
          <TextField label="Contact phone" value={c.contact_phone} onChange={k("contact_phone")} testid="content-contact-phone" />
          <TextField label="Street address (private unless shown below)" value={c.address} onChange={k("address")} testid="content-address" />
          <TextField area rows={2} label="Arrival notes (sent only in confirmation email)" value={c.arrival_notes} onChange={k("arrival_notes")} testid="content-arrival-notes" />
          <TextField label="Airbnb rating" type="number" value={c.rating} onChange={k("rating")} testid="content-rating" />
          <TextField label="Airbnb review count" type="number" value={c.review_count} onChange={k("review_count")} testid="content-review-count" />
        </div>
        <div className="mt-6 space-y-3">
          <Toggle label="Show address and map publicly" checked={c.show_address} onChange={k("show_address")} testid="toggle-show-address" />
          <Toggle label="Show Airbnb rating section" checked={c.show_rating} onChange={k("show_rating")} testid="toggle-show-rating" />
          <Toggle label="Show 'Airbnb Guest Favorite' line" checked={c.guest_favorite} onChange={k("guest_favorite")} testid="toggle-guest-favorite" />
        </div>
      </Panel>
      <SaveButton onClick={save} busy={busy} testid="save-content-button" label="Save all content" />
    </>
  );
};
